import { userConstants } from '../constants';

export function user(state = {}, action) {
  switch (action.type) {
    case userConstants.GETALL_REQUEST:
      return state;
    case userConstants.GETALL_SUCCESS:
      return { ...state, users: action.usersList, total: action.total };
    case userConstants.GETALL_FAILURE:
      return { ...state, error: action.error };
    default:
      return state;
  }
}

export function users(state = {}, action) {
  switch (action.type) {
    case userConstants.GETALL_REQUEST:
      return {
        state,
        loading: true
      }
    case userConstants.GETALL_SUCCESS:
      return {
        ...state,
        items: action.items,
        total: action.total,
        loading: false
      }
    case userConstants.GETALL_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false
      };
    default:
      return state;
  }
}

export function AddUser(state = {}, action) {
  switch (action.type) {
    case userConstants.ADD_REQUEST:
      return {
        state,
        loading: true,
      }
    case userConstants.ADD_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case userConstants.ADD_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}

export function GetUser(state = {}, action) {
  switch (action.type) {
    case userConstants.GET_REQUEST:
      return {
        state,
        loading: true,
      }
    case userConstants.GET_SUCCESS:
      return {
        ...state,
        item: action.item,
        loading: false
      }
    case userConstants.GET_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
      };
    default:
      return state;
  }
}

export function UpdateUser(state = {}, action) {
  switch (action.type) {
    case userConstants.UPDATE_REQUEST:
      return {
        state,
        loading: true,
      }
    case userConstants.UPDATE_SUCCESS:
      return {
        ...state,
        status: action.status,
        loading: false
      }
    case userConstants.UPDATE_FAILURE:
      return {
        ...state,
        error: action.error,
        loading: false,
        status: false
      };
    default:
      return state;
  }
}